import { createNamespacedHelpers } from 'vuex';
import get from 'lodash/get';
import { Media } from '@/mixins/media';
import ChatDefs from '@/store/chat/chat.d';
import ConciergeDefs from '@/store/concierge/concierge.d';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import levelNames from '@/config/levelNames.json';
import flags from '@/config/flags.json';

const {
  mapActions: mapConciergeActions,
  mapState: mapConciergeState
} = createNamespacedHelpers('Concierge');

const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');

const emptyLocale = { ['en-US']: '', ['zh-TW']: '', ['zh-CN']: '' };

export default {
  name: 'SettingProfile',
  components: { LoadingDots },
  mixins: [Media],
  data: () => ({
    iconFile: null,
    profileFile: null,
    levelNames,
    flags,
    form: {
      screenName: '',
      languages: [],
      descriptions: Object.assign({}, emptyLocale),
      locations: Object.assign({}, emptyLocale),
      flag: 'jp',
      conciergeLevel: 0,
      isSuperConcierge: false,
      profileUrl: null,
      profilePhoto: null
    }
  }),

  computed: {
    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge
    })
  },

  watch: {
    currentConcierge: {
      handler: 'loadForm',
      immediate: true
    }
  },

  methods: {
    ...mapChatActions({
      chatStore_updateUserInfo: ChatDefs.actions.updateUserInfo
    }),

    ...mapConciergeActions({
      conciergeStore_updateConcierge: ConciergeDefs.actions.updateConcierge
    }),

    loadForm: function() {
      const { currentConcierge } = this;
      this.form.screenName = currentConcierge.screenName;
      this.form.languages = currentConcierge.languages;
      this.form.isSuperConcierge = currentConcierge.isSuperConcierge;
      this.form.conciergeLevel = currentConcierge.conciergeLevel;
      this.form.flag = get(currentConcierge, 'flag[0]', '');

      this.form.descriptions = currentConcierge.descriptions || emptyLocale;
      this.form.locations = currentConcierge.locations || emptyLocale;
    },

    handleOnIconChange: function(e) {
      this.iconFile = e.target.files[0];
    },

    handleOnProfileChange: function(e) {
      this.profileFile = e.target.files[0];
    },

    /**
     * Handler for upload the image
     * both of profile photo and icons
     */
    handleUploadImage: async function() {
      const { iconFile, profileFile } = this;

      // Image photo on small avatar chat
      if (iconFile) {
        const uploadedIcon = await this.uploadImage(iconFile, 'agent');
        this.form.profileUrl = uploadedIcon.url;
      }

      // Image photo on concierge profile
      if (profileFile) {
        const uploadedProfile = await this.uploadImage(profileFile, 'agent');
        this.form.profilePhoto = uploadedProfile.url;
      }
    },

    /**
     * Handler when the button of save is clicked
     */
    // eslint-disable-next-line max-lines-per-function
    handleOnSaveClick: async function() {
      const {
        descriptions,
        locations,
        flag,
        // eslint-disable-next-line  no-unused-vars
        conciergeLevel,
        ...form
      } = this.form;
      this.$loading.start('settings.saveProfile');

      try {
        // Update general information
        const payload = {
          ...form,
          flag: [flag]
        };

        payload.description = {};
        payload.locations = {};
        payload.languages.forEach(language => {
          if (descriptions[language]) {
            payload.description[language] = descriptions[language];
          }

          if (locations[language]) {
            payload.locations[language] = locations[language];
          }
        });

        await this.handleUploadImage();

        const chatPayload = {
          screenName: this.form.screenName,
          profileUrl: this.form.profileUrl
        };

        await this.chatStore_updateUserInfo(chatPayload);
        await this.conciergeStore_updateConcierge(payload);

        this.$toast.open({
          message: 'Profile has been saved successfully. ',
          position: 'top-right'
        });
      } catch (error) {
        // TODO: handle error correctly
        this.$toast.open({
          type: 'error',
          message: 'Something happens, profile save was failed. ',
          position: 'top-right'
        });
      }

      this.$loading.end('settings.saveProfile');
    }
  }
};
